import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { IDatePickerConfig } from 'ng2-date-picker';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { CanceledFilter } from 'src/app/shared/models/canceledFilter.model';
import { CanceledService } from 'src/app/shared/services/core/canceled.service';

@Component({
  selector: 'app-canceladas',
  imports: [TegelModule, CommonModule],
  templateUrl: './canceladas.component.html',
  styleUrl: './canceladas.component.scss'
})
export class CanceladasComponent implements OnInit{
  canceled: any[];
  canceledFilter: CanceledFilter;
  page = 1;
  total: number = 0;
  reverse: boolean = false;
  order = "ID";

  dateConfigPeriodFrom: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigUpTo: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  constructor(
    private canceledService: CanceledService,
    private dialogService: DialogService, 
    private utilService: UtilService
  ) {
    this.canceledFilter = new CanceledFilter();
    this.canceled = [];
  }

  ngOnInit(): void {}

  changeDateFrom(value: any){
    this.dateConfigUpTo.min = value;
    this.dateConfigUpTo = { ...this.dateConfigPeriodFrom };
  }

  changeDateTo(value: any) {
    this.dateConfigPeriodFrom.max = value;
    this.dateConfigPeriodFrom = { ...this.dateConfigPeriodFrom };
  }


  // chooseClient() {
  //   this.dialogService.addDialog(ClientComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.client != null) {
  //       const client = result.client;
  //       this.canceledFilter.clientId = client.id;
  //       this.canceledFilter.corporateName = client.corporateName;
  //     }
  //   });
  // }

  getAllCanceled(page: number) {
    this.canceledService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.canceledFilter).subscribe((result) => {
      this.canceled = result.page;
      this.page = result.currentPage;
      this.total = result.totalRecords;
    });
  }

  resetFilters(form: NgForm){
    this.canceledFilter = new CanceledFilter();
    form.resetForm(this.canceledFilter);

    this.changeDateFrom(null);
    this.changeDateTo(null);
  }

  search() {
    this.getAllCanceled(1);
  }
}
